export const type = 'form.checkboxList';
